import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // Public Routes
  {
    path: '/',
    name: 'home',
    component: () => import('../pages/public/Home.vue'),
    meta: { title: 'Sinau Bareng — Ekosistem Belajar OBE' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/auth/Login.vue'),
    meta: { title: 'Masuk | Portal Sinau' }
  },
  {
    path: '/login/:role(mahasiswa|dosen|admin)',
    name: 'login-role',
    component: () => import('../pages/auth/Login.vue'),
    meta: { title: 'Masuk | Portal Sinau' }
  },
  {
    path: '/contributor',
    name: 'contributor',
    component: () => import('../pages/contributor/Detail.vue'),
    meta: { title: 'Kontributor | Sinau Bareng' }
  },
  {
    path: '/contributor/:id',
    name: 'contributor-detail',
    component: () => import('../pages/contributor/Detail.vue'),
    meta: { title: 'Detail Kontributor | Sinau Bareng' }
  },
  {
    path: '/builder',
    name: 'builder',
    component: () => import('../pages/builder/Builder.vue'),
    meta: { title: 'Builder | Portal Sinau' }
  },
  {
    path: '/cv-editor',
    name: 'cv-editor',
    component: () => import('../pages/cv/Editor.vue'),
    meta: { title: 'CV Editor | Portal Sinau' }
  },
  {
    path: '/preview/material/:id?',
    component: () => import('../pages/public/MaterialPreviewView.vue'),
    meta: { title: 'Pratinjau Materi | Sinau Bareng' }
  },
  {
    path: '/preview/:id?',
    component: () => import('../pages/public/MaterialPreviewView.vue'),
    meta: { title: 'Pratinjau Materi | Sinau Bareng' }
  },

  // DOSEN PORTAL ROUTES
  {
    path: '/dosen',
    redirect: '/dosen/dashboard'
  },
  {
    path: '/dosen/dashboard',
    name: 'dosen-dashboard',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Dashboard | Portal Dosen | Portal Sinau', role: 'dosen', view: 'dashboard' }
  },
  {
    path: '/dosen/mata-kuliah',
    name: 'dosen-courses',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Mata Kuliah Diampu | Portal Dosen | Portal Sinau', role: 'dosen', view: 'courses' }
  },
  {
    path: '/dosen/mahasiswa',
    name: 'dosen-mahasiswa',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Daftar Mahasiswa | Portal Dosen | Portal Sinau', role: 'dosen', view: 'data-mahasiswa' }
  },
  {
    path: '/dosen/dosen',
    name: 'dosen-lecturers',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Daftar Dosen | Portal Dosen | Portal Sinau', role: 'dosen', view: 'lecturers' }
  },
  {
    path: '/dosen/tugas',
    name: 'dosen-tugas',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Tugas & Asesmen | Portal Dosen | Portal Sinau', role: 'dosen', view: 'assignments' }
  },
  {
    path: '/dosen/nilai',
    name: 'dosen-nilai',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Nilai & Rekapitulasi | Portal Dosen | Portal Sinau', role: 'dosen', view: 'grades' }
  },
  {
    path: '/dosen/online-users',
    name: 'dosen-online-users',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Pengguna Online | Portal Dosen | Portal Sinau', role: 'dosen', view: 'online-users' }
  },
  {
    path: '/dosen/profil',
    name: 'dosen-profil',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Edit Profil | Portal Dosen | Portal Sinau', role: 'dosen', view: 'profil' }
  },
  {
    path: '/dosen/ganti-password',
    name: 'dosen-change-password',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { title: 'Ganti Password | Portal Dosen | Portal Sinau', role: 'dosen', view: 'change-password' }
  },
  { path: '/dosen/change-password', redirect: '/dosen/ganti-password' },
  {
    path: '/dosen/mata-kuliah/:courseId',
    name: 'dosen-course-detail',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { role: 'dosen', isCourseDetail: true }
  },
  {
    path: '/dosen/mata-kuliah/:courseId/:tab',
    name: 'dosen-course-tab',
    component: () => import('../pages/dosen/Dashboard.vue'),
    meta: { role: 'dosen', isCourseDetail: true }
  },

  // MAHASISWA PORTAL ROUTES
  {
    path: '/mahasiswa',
    redirect: '/mahasiswa/dashboard'
  },
  {
    path: '/mahasiswa/dashboard',
    name: 'mahasiswa-dashboard',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Dashboard | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'dashboard' }
  },
  {
    path: '/mahasiswa/mata-kuliah',
    name: 'mahasiswa-courses',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Mata Kuliah Terdaftar | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'courses' }
  },
  {
    path: '/mahasiswa/katalog',
    name: 'mahasiswa-katalog',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Katalog Kelas | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'catalog' }
  },
  { path: '/mahasiswa/katalog-kelas', redirect: '/mahasiswa/katalog' },
  {
    path: '/mahasiswa/tugas',
    name: 'mahasiswa-tugas',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Tugas Kuliah Saya | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'assignments' }
  },
  {
    path: '/mahasiswa/nilai',
    name: 'mahasiswa-nilai',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Transkrip & Nilai | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'grades' }
  },
  {
    path: '/mahasiswa/mahasiswa',
    name: 'mahasiswa-students',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Daftar Mahasiswa | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'data-mahasiswa' }
  },
  {
    path: '/mahasiswa/dosen',
    name: 'mahasiswa-dosen',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Daftar Dosen | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'lecturers' }
  },
  {
    path: '/mahasiswa/online-users',
    name: 'mahasiswa-online-users',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Pengguna Online | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'online-users' }
  },
  {
    path: '/mahasiswa/profil',
    name: 'mahasiswa-profil',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Edit Profil | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'profil' }
  },
  {
    path: '/mahasiswa/ganti-password',
    name: 'mahasiswa-change-password',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { title: 'Ganti Password | Portal Mahasiswa | Portal Sinau', role: 'mahasiswa', view: 'change-password' }
  },
  { path: '/mahasiswa/change-password', redirect: '/mahasiswa/ganti-password' },
  {
    path: '/mahasiswa/mata-kuliah/:courseId',
    name: 'mahasiswa-course-detail',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { role: 'mahasiswa', isCourseDetail: true }
  },
  {
    path: '/mahasiswa/mata-kuliah/:courseId/:tab',
    name: 'mahasiswa-course-tab',
    component: () => import('../pages/mahasiswa/Dashboard.vue'),
    meta: { role: 'mahasiswa', isCourseDetail: true }
  },

  // ADMIN PORTAL ROUTES
  {
    path: '/admin',
    redirect: '/admin/dashboard'
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Dashboard | Portal Admin | Portal Sinau', role: 'admin', view: 'dashboard' }
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Manajemen Pengguna | Portal Admin | Portal Sinau', role: 'admin', view: 'users' }
  },
  {
    path: '/admin/mahasiswa',
    name: 'admin-mahasiswa',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Daftar Mahasiswa | Portal Admin | Portal Sinau', role: 'admin', view: 'data-mahasiswa' }
  },
  {
    path: '/admin/mata-kuliah',
    name: 'admin-courses',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Semua Mata Kuliah | Portal Admin | Portal Sinau', role: 'admin', view: 'all-courses' }
  },
  {
    path: '/admin/tugas',
    name: 'admin-tugas',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Semua Tugas | Portal Admin | Portal Sinau', role: 'admin', view: 'all-assignments' }
  },
  {
    path: '/admin/nilai',
    name: 'admin-nilai',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Semua Nilai | Portal Admin | Portal Sinau', role: 'admin', view: 'all-grades' }
  },
  {
    path: '/admin/dosen',
    name: 'admin-dosen',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Daftar Dosen | Portal Admin | Portal Sinau', role: 'admin', view: 'lecturers' }
  },
  {
    path: '/admin/pengumuman',
    name: 'admin-announcements',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Pengumuman | Portal Admin | Portal Sinau', role: 'admin', view: 'announcements' }
  },
  {
    path: '/admin/pengaturan',
    name: 'admin-settings',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Pengaturan Sistem | Portal Admin | Portal Sinau', role: 'admin', view: 'settings' }
  },
  {
    path: '/admin/ganti-password',
    name: 'admin-change-password',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Ganti Password | Portal Admin | Portal Sinau', role: 'admin', view: 'change-password' }
  },
  { path: '/admin/change-password', redirect: '/admin/ganti-password' },
  {
    path: '/admin/bulk-import',
    name: 'admin-bulk-import',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Bulk Import | Portal Admin | Portal Sinau', role: 'admin', view: 'bulk-import' }
  },
  // SHARED AUTHENTICATED ROUTES
  {
    path: '/online-users',
    name: 'online-users',
    component: () => import('../pages/shared/OnlineUsers.vue'),
    meta: { title: 'Pengguna Online | Portal Sinau', requiresAuth: true, view: 'online-users' }
  },
  { path: '/dosen/online-users', redirect: '/online-users' },
  { path: '/mahasiswa/online-users', redirect: '/online-users' },
  { path: '/admin/online-users', redirect: '/online-users' },
  { path: '/account/change-password', redirect: '/mahasiswa/ganti-password' },

  {
    path: '/admin/system-migration',
    name: 'admin-system-migration',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { title: 'Migrasi Sistem | Portal Admin | Portal Sinau', role: 'admin', view: 'system-migration' }
  },
  {
    path: '/admin/mata-kuliah/:courseId',
    name: 'admin-course-detail',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { role: 'admin', isCourseDetail: true }
  },
  {
    path: '/admin/mata-kuliah/:courseId/:tab',
    name: 'admin-course-tab',
    component: () => import('../pages/admin/Dashboard.vue'),
    meta: { role: 'admin', isCourseDetail: true }
  },

  // Legacy HTML Redirects
  {
    path: '/dashboard',
    redirect: () => {
      const userRole = normalizeRole(window.AppState?.role || (JSON.parse(localStorage.getItem('portal_user') || '{}')?.role))
      return getRoleHome(userRole)
    }
  },
  { path: '/index.html', redirect: '/' },
  { path: '/login.html', redirect: '/login' },
  { path: '/admin.html', redirect: '/admin/dashboard' },
  { path: '/dosen.html', redirect: '/dosen/dashboard' },
  { path: '/mahasiswa.html', redirect: '/mahasiswa/dashboard' },

  // Catch-all
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

import { canAccessView, normalizeRole, getRoleHome } from '../utils/permissions.js'
import { topProgress } from '../services/topProgressService.js'
import { useLoadingStore } from '../stores/loading.js'

// Global navigation guards for document title, permissions & route-based loading
router.beforeEach((to, from) => {
  // Instant (0ms) top progress bar trigger on any click navigation
  try {
    topProgress.start()
  } catch (e) {}

  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  // Permission & Role Guard
  if (to.meta && to.meta.role && typeof window !== 'undefined') {
    const userRole = normalizeRole(window.AppState?.role || (JSON.parse(localStorage.getItem('portal_user') || '{}')?.role))
    const requiredRole = normalizeRole(to.meta.role)
    const viewKey = to.meta.view

    if (userRole !== requiredRole || (viewKey && !canAccessView(userRole, viewKey))) {
      const targetHome = getRoleHome(userRole)
      console.warn(`[PermissionGuard] Access denied for role '${userRole}' on route '${to.path}'. Redirecting to ${targetHome}...`)
      return targetHome
    }
  }

  try {
    const loading = useLoadingStore()
    loading.startLoading('Menavigasi Halaman...')
  } catch (e) {
    // Ignore loading store failure
  }
})

router.afterEach((to) => {
  try {
    topProgress.finish()
  } catch (e) {}

  try {
    const loading = useLoadingStore()

    // For dashboard and role-based routes, the view has NOT finished rendering yet;
    // Dashboard.vue's waitForViewReady lifecycle ensures the loader remains visible
    // until the DOM content is actually painted. Only auto-dismiss for static/public pages.
    const isDashboardRoute = to.path.startsWith('/mahasiswa') ||
                             to.path.startsWith('/dosen') ||
                             to.path.startsWith('/admin') ||
                             Boolean(to.meta?.role)

    if (!isDashboardRoute) {
      setTimeout(() => {
        loading.stopLoading()
      }, 100)
    }
  } catch (e) {
    // Ignore
  }
})

router.onError((error) => {
  try {
    topProgress.fail()
  } catch (e) {}

  if (error?.message?.includes('Failed to fetch dynamically imported module') || error?.message?.includes('Importing a module script failed')) {
    console.warn('Chunk loading failed due to new build deployment. Auto-reloading page...')
    window.location.reload()
  }
})

export default router

